export const states = [
  { name: "AL", label: "AL", value: "AL" },
  { name: "AK", label: "AK", value: "AK" },
  { name: "AS", label: "AS", value: "AS" },
  { name: "AZ", label: "AZ", value: "AZ" },
  { name: "AR", label: "AR", value: "AR" },
  { name: "CA", label: "CA", value: "CA" },
  { name: "CO", label: "CO", value: "CO" },
  { name: "CT", label: "CT", value: "CT" },
  { name: "DE", label: "DE", value: "DE" },
  { name: "DC", label: "DC", value: "DC" },
  { name: "FM", label: "FM", value: "FM" },
  { name: "FL", label: "FL", value: "FL" },
  { name: "GA", label: "GA", value: "GA" },
  { name: "GU", label: "GU", value: "GU" },
  { name: "HI", label: "HI", value: "HI" },
  { name: "ID", label: "ID", value: "ID" },
  { name: "IL", label: "IL", value: "IL" },
  { name: "IN", label: "IN", value: "IN" },
  { name: "IA", label: "IA", value: "IA" },
  { name: "KS", label: "KS", value: "KS" },
  { name: "KY", label: "KY", value: "KY" },
  { name: "LA", label: "LA", value: "LA" },
  { name: "ME", label: "ME", value: "ME" },
  { name: "MH", label: "MH", value: "MH" },
  { name: "MD", label: "MD", value: "MD" },
  { name: "MA", label: "MA", value: "MA" },
  { name: "MI", label: "MI", value: "MI" },
  { name: "MN", label: "MN", value: "MN" },
  { name: "MS", label: "MS", value: "MS" },
  { name: "MO", label: "MO", value: "MO" },
  { name: "MT", label: "MT", value: "MT" },
  { name: "NE", label: "NE", value: "NE" },
  { name: "NV", label: "NV", value: "NV" },
  { name: "NH", label: "NH", value: "NH" },
  { name: "NJ", label: "NJ", value: "NJ" },
  { name: "NM", label: "NM", value: "NM" },
  { name: "NY", label: "NY", value: "NY" },
  { name: "NC", label: "NC", value: "NC" },
  { name: "ND", label: "ND", value: "ND" },
  { name: "MP", label: "MP", value: "MP" },
  { name: "OH", label: "OH", value: "OH" },
  { name: "OK", label: "OK", value: "OK" },
  { name: "OR", label: "OR", value: "OR" },
  { name: "PW", label: "PW", value: "PW" },
  { name: "PA", label: "PA", value: "PA" },
  { name: "PR", label: "PR", value: "PR" },
  { name: "RI", label: "RI", value: "RI" },
  { name: "SC", label: "SC", value: "SC" },
  { name: "SD", label: "SD", value: "SD" },
  { name: "TN", label: "TN", value: "TN" },
  { name: "TX", label: "TX", value: "TX" },
  { name: "UT", label: "UT", value: "UT" },
  { name: "VT", label: "VT", value: "VT" },
  { name: "VI", label: "VI", value: "VI" },
  { name: "VA", label: "VA", value: "VA" },
  { name: "WA", label: "WA", value: "WA" },
  { name: "WV", label: "WV", value: "WV" },
  { name: "WI", label: "WI", value: "WI" },
  { name: "WY", label: "WY", value: "WY" }
];
